const emcLeadStatDefaultState = {
    data: [],
    singleItem: {},
    loading: false,
    error: false,
    success: false,
    deleteSuccess: false,
    successMessage: '',
    uploadLeadSuccess: false,
    errorMessage: null
};

const emcLeadStatReducer = (state = emcLeadStatDefaultState, action) => {
    switch (action.type) {
        case 'START_GET_EMC_LEAD_STAT':
            return {
                ...state,
                loading: true,
                error: false,
                errorMessage: null,
                successMessage: '',
                uploadLeadSuccess: false,
            };
        case 'GET_EMC_LEAD_STAT_SUCCESS':
            return {
                ...state,
                singleItem: action.emcLeadStat,
                loading: false,
                error: false,
                errorMessage: null,
            };
        case 'START_GET_EMC_LEAD_STATS':
            return {
                ...state,
                loading: true,
                error: false,
                errorMessage: null,
                successMessage: '',
                success: false,
                uploadLeadSuccess: false,
            };
        case 'GET_EMC_LEAD_STATS_SUCCESS':
            return {
                ...state,
                data: action.emcLeadStats,
                loading: false,
                error: false,
                errorMessage: null,
            };
        case 'CREATE_EMC_LEAD_STAT_SUCCESS':
            return {
                ...state,
                data: action.emcLeadStats,
                loading: false,
                uploadLeadSuccess: true,
                error: false,
                errorMessage: null,
                successMessage: 'News Alert has been updated',

            };
        case 'CREATE_EMC_LEAD_STAT_CLEAR_SUCCESS':
            return {
                ...state,
                uploadLeadSuccess: false,
                successMessage: '',
            };
        case 'START_STATS_EMC_UPDATE':
            return {
                ...state,
                loading: true,
                error: false,
                errorMessage: null,
                successMessage: '',
            };
        case 'UPDATE_STATS_EMC_SUCCESS':
            return {
                ...state,
                data: action.statsEmail,
                loading: false,
                success: true,
                error: false,
                errorMessage: null,
                successMessage: 'EMC Stat has been updated',
            };
        case 'START_REMOVE_EMC_LEAD_STAT':
            return {
                ...state,
                loading: true,
                error: false,
                errorMessage: null,
                successMessage: '',
            };
        case 'REMOVE_EMC_LEAD_STAT_SUCCESS':
            return {
                ...state,
                data: state.data.filter(lead => { // check original posts and only include posts that don't have that to delete ID
                    return !action.emcLeadStatIds.includes(lead.id); // includes is checking inside an array of numbers to see if any match
                }),
                loading: false,
                deleteSuccess: true,
                error: false,
                errorMessage: null,
                successMessage: 'Your leads have been removed!',
            };
        case 'REMOVE_EMC_LEAD_STAT_CLEAR_SUCCESS':
            return {
                ...state,
                deleteSuccess: false,
                successMessage: '',
            };
        case 'SHOW_ERROR':
            return {
                ...state,
                loading: false,
                error: true,
                successMessage: '',
                errorMessage: action.errorMessage
            };
        default:
            return state;
    }
};

export default emcLeadStatReducer;